
import { importSync as i, macroCondition, getGlobalConfig } from '@embroider/macros';
let w = window;
let d = w.define;


i("./-embroider-implicit-modules.js");

d("precision-studio/app", function(){ return i("precision-studio/app.js");});
d("precision-studio/config/environment", function(){ return i("precision-studio/config/environment.js");});
d("precision-studio/deprecation-workflow", function(){ return i("precision-studio/deprecation-workflow.ts");});
d("precision-studio/formats", function(){ return i("precision-studio/formats.js");});
d("precision-studio/router", function(){ return i("precision-studio/router.js");});
d("precision-studio/services/feedback", function(){ return i("precision-studio/services/feedback.js");});
d("precision-studio/services/logger", function(){ return i("precision-studio/services/logger.js");});
d("precision-studio/services/aditools-analytics", function(){ return i("precision-studio/services/aditools-analytics.js");});
d("precision-studio/services/aditools-site", function(){ return i("precision-studio/services/aditools-site.js");});
d("precision-studio/services/intl", function(){ return i("precision-studio/services/intl.js");});
d("precision-studio/services/page-title", function(){ return i("precision-studio/services/page-title.js");});
d("precision-studio/instance-initializers/load-translations", function(){ return i("precision-studio/instance-initializers/load-translations.js");});
d("precision-studio/initializers/app-version", function(){ return i("precision-studio/initializers/app-version.js");});
d("precision-studio/templates/index", function(){ return i("precision-studio/templates/index.hbs");});
d("precision-studio/controllers/index", function(){ return i("precision-studio/controllers/index.js");});
d("precision-studio/routes/index", function(){ return i("precision-studio/routes/index.js");});
d("precision-studio/templates/application", function(){ return i("precision-studio/templates/application.hbs");});





if (!runningTests) {
  i("../app").default.create({"name":"precision-studio","version":"2.23.0+a071bc85"});
}

